import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import type { TaxAssistantReplyStatus } from '@/features/jobs/taxes/assistant/tax-assistant-reply-status'
import { unixEpoch } from '@/utils/date-util'

export type JobTaxAssistantProps = ModelProps<JobTaxAssistant>

/**
 * JobTaxAssistant
 */
export class JobTaxAssistant extends Model<JobTaxAssistant> {
  jobId = Id.none

  @observable accessor replyStatus: TaxAssistantReplyStatus = 'Idle'
  @observable accessor externalReplyId: Id | null = null
  @observable accessor active = true
  @observable accessor lastUpdated = unixEpoch()
}
